{
  "nl": {
    "pupilFeedback": {
      "deprecationAlert": {
        "title": "Deze tool is standaard verborgen",
        "description": "Het kan op verzoek op schoolniveau worden geactiveerd.",
        "learnMoreLink": "Meer informatie"
      },
      "unlockedAlert": {
        "title": "Deze tool is geactiveerd voor jouw school",
        "description": "Het wordt niet verder ontwikkeld, maar blijft bruikbaar voor jouw school.",
        "learnMoreLink": "Meer informatie"
      },
      "alerts": {
        "example": "Hoe kan dat eruitzien?",
        "exampleButton": "Voorbeeld van taak en criteria invoegen",
        "noFeedbackYet": "Er kon geen feedback worden gegenereerd. Controleer je invoer en probeer het opnieuw.",
        "pupilFeedback": "<strong>Let op:</strong> De feedback is automatisch gegenereerd door AI op basis van de opgegeven criteria en kan fouten bevatten. Neem bij vragen of onduidelijkheden contact op met je docent.",
        "pupilFeedbackStudent": "<strong>Let op:</strong> De feedback wordt gegenereerd met behulp van AI en is gebaseerd op de taken, materialen en criteria die door je docent zijn vastgesteld. Neem bij vragen of onduidelijkheden contact op met je docent.",
        "submitting": "Je feedback wordt nu gegenereerd.",
        "submittingDescription": "Even geduld a.u.b."
      },
      "example": {
        "criteriaAttributes": {
          "0": "Het verhaal volgt een logische verhaalstructuur en heeft een titel, een inleiding, een middenstuk en een slot. De gebeurtenissen bouwen op elkaar voort en leiden tot een kort einde, waarbij de titel past bij het thema van het verhaal.",
          "1": "Het verhaal gebruikt stijlmiddelen om spannend te zijn. Je gebruikt beschrijvende woorden (zoals 'griezelig', 'onheilspellend', 'donker') en beschrijft precies wat de personen zien, horen en voelen.",
          "2": "De grammatica en spelling van het verhaal zijn correct. Je let op juiste zinsstructuren, correcte tijden en spelling, zodat de tekst vloeiend leest.",
          "3": "Het verhaal bevat afwisselende zinsbeginningen."
        },
        "description": "Lees het krantenartikel 'Nacht in het Moeras'. Schrijf een griezelverhaal op basis van de gebeurtenissen. Let daarbij op de ontwerpcriteria om je verhaal zo spannend mogelijk te maken.",
        "material": "<strong>Krantenartikel</strong><br>CARLSFELD. Een vader moest met zijn kinderen een griezelige nacht doorbrengen in een moeras bij Carlsfeld. Na een lekke band probeerde de heer T. met Maria (12) en Tom (10) te voet naar huis te komen. Bij vorst en mist verdwaalden ze echter in het moeras. Een grootschalige zoekactie van de politie, die door de bezorgde moeder was gestart, had pas 's ochtends succes: speurhonden van de politie vonden de drie volledig onderkoeld.",
        "name": "Griezelverhaal"
      },
      "flash": {
        "textExtractionSuccess": "Tekstextractie succesvol"
      },
      "headings": {
        "criteria": "Criterium",
        "form": "Taak en criteria vaststellen"
      },
      "hints": {
        "experimental": "De tool Feedback voor Leerlingen genereert <strong>AI-gegenereerde feedback</strong> op basis van de door de docent opgegeven taak, materialen en criteria. Om de feedback verantwoord te interpreteren, moeten de aanbevolen <strong>randvoorwaarden en beperkingen van de AI</strong> absoluut worden gelezen en in acht worden genomen. <a href='https://app.fobizz.com/de/help/articles/251-feedback-tool-ki' target='_blank'>Meer informatie</a>",
        "noSubmission": "Nog niet ingeleverd",
        "submitSuccessful": "Hartelijk dank! Je hebt je taak succesvol ingeleverd.",
        "submitSuccessfulShort": "Taak succesvol verzonden"
      },
      "infoMessages": {
        "criteria": "Stel criteria vast op basis waarvan de AI feedback moet geven. Hoe preciezer je de criteria formuleert, hoe nauwkeuriger de feedback is.",
        "criterion": "Minstens één criterium vereist"
      },
      "labels": {
        "allResponses": "Alle antwoorden",
        "answer": "Antwoord",
        "assignment": "Werkopdracht",
        "assignmentTitle": "Taaktitel",
        "averageScore": "Totaalbeoordeling:",
        "criteria": "Feedbackcriteria",
        "criteriaVisibleForPupils": "Zichtbaar voor leerlingen",
        "difference": "Verschillen met de 1e versie",
        "draftsAndSubmissions": "Concepten en inleveringen",
        "editFeedback": "Antwoord bewerken",
        "emptySubmission": {
          "description": "Deel de taak met je leerlingen. Zodra zij hun eerste feedback opvragen, zie je hier de voortgang.",
          "title": "Voor deze taak zijn er nog geen concepten of inleveringen."
        },
        "feedback": "Feedback",
        "finalSubmission": "Inlevering | Inleveringen",
        "finalSubmit": "Taak inleveren",
        "firstSubmission": "1e versie | 1e versies",
        "material": "Materiaal",
        "materialVisibleForPupils": "Zichtbaar voor leerlingen",
        "noScoreYet": "Beoordeling nog open",
        "of": "van {count}",
        "score": "Beoordeling",
        "submit": "Geef me feedback"
      },
      "links": {
        "imageRecognition": "Tekst uit afbeelding gebruiken",
        "textExtraction": "Tekst uit PDF gebruiken",
        "toggleFeedbackDetails": "Feedback tonen"
      },
      "modals": {
        "confirm": {
          "helpLink": "https://app.fobizz.com/de/help/articles/251-feedback-tool-ki",
          "text": "De tool Feedback voor Leerlingen genereert AI-gegenereerde feedback op basis van de door de docent opgegeven taak, materialen en criteria. Om de feedback verantwoord te interpreteren, moeten de aanbevolen randvoorwaarden en beperkingen van de AI absoluut worden gelezen en in acht worden genomen.",
          "title": "Instructies voor het gebruik van de feedbacktools"
        }
      },
      "placeholders": {
        "answer": "Voer hier je antwoord in...",
        "assignment": "Voer hier de werkopdracht in...",
        "assignmentTitle": "Voer een naam voor de taak in...",
        "criterion": "Voer een criterium in...",
        "language": "Taal voor de AI-feedback",
        "material": "Voeg hier ondersteuning of aanvullend materiaal voor het maken van de taak in."
      },
      "responseItem": {
        "confirmDelete": {
          "confirm": "Verwijderen",
          "text": "Deze actie kan niet ongedaan worden gemaakt. Het antwoord wordt permanent verwijderd.",
          "title": "Antwoord verwijderen?"
        },
        "delete": "Antwoord verwijderen",
        "firstFeedback": "1e versie",
        "share": "Toegangslink kopiëren",
        "submission": "Inlevering"
      },
      "simpleLanguage": {
        "loading": "Even geduld...",
        "translate": "Feedback in eenvoudige taal tonen"
      }
    },
    "pupil_feedback": {
      "anonymous": "Anoniem"
    }
  }
}
